import { FabricComment } from 'src/components/conversation-provider/types';

export const commentHasCodeSuggestions = (comment: FabricComment): boolean => {
  return (
    comment.document?.adf?.content.some(
      content =>
        content.type === 'extension' &&
        content.attrs.extensionKey === 'codesuggestions:suggestion-node' &&
        content.attrs.extensionType === 'com.atlassian.bbc.code-suggestions'
    ) ?? false
  );
};
